import { createStorageProvider } from "app/pages/sales-intelligence/services/storage/factory";

import type { IStorageManager, StorageConfigList } from "./types";

export function createStorageManager(storage: Storage, makeKey: (key: string) => string): IStorageManager {
    const provider = createStorageProvider(storage, makeKey);

    return {
        provider,

        configList<K extends Record<string, { key: string; defaultValue: unknown }>>(keys: K) {
            return Object.fromEntries(
                Object.entries(keys).map(([name, { key, defaultValue }]) => [
                    name,
                    { item: { key: makeKey(key), initialValue: defaultValue }, storage },
                ]),
            ) as StorageConfigList<K>;
        },
    };
}
